// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__1ZLed","infoBtn":"quickbooks_infoBtn__1UdX-","formBox":"quickbooks_formBox__1uwuz","formFooter":"quickbooks_formFooter__3T4AP"};